"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchHeaders = void 0;
var FetchHeaders = /** @class */ (function () {
    function FetchHeaders(fetchHeaders) {
        this.get = fetchHeaders.get.bind(fetchHeaders);
        this.has = fetchHeaders.has.bind(fetchHeaders);
    }
    FetchHeaders.prototype.get = function (_) {
        return null;
    };
    FetchHeaders.prototype.has = function (_) {
        return false;
    };
    return FetchHeaders;
}());
exports.FetchHeaders = FetchHeaders;
//# sourceMappingURL=headers.js.map